import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next"
const ReservationTimer = ({ initialSeconds = 100 }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  const [expired, setExpired] = useState(false);
  const { t } = useTranslation()
  useEffect(() => {
    if (secondsLeft <= 0) {
      setExpired(true);
      return;
    }

    const interval = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsLeft]);

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className='mt-2 bold font-tiny'>
      {!expired ? (
        <span>
          {' '}
          {t('timerLock', {
            timerLock: formatTime(secondsLeft),
          })}
        </span>
      ) : (
        <span style={{ color: 'red' }}>{t('tableIsNoLongerAvailable')}</span>
      )}
    </div>
  );
};

export default ReservationTimer;
